// Copyright (c) 2019 Deere & Company

import './app-greeting.scss';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';
import { TextDropdown } from '../../../../sharedmodules/components/form-fields/text-drop-down/text-dropdown';
import { connect } from 'react-redux';
import { withAuth } from '@okta/okta-react';

const AppGreeting = ({ userDetails, auth }) => (
    <div className="app-greeting">
        <span><FormattedMessage id="WELCOME" /></span>
        <span className="user-name">
            <TextDropdown text={userDetails} auth={auth} />
        </span>
    </div>
);

AppGreeting.propTypes = {
    user: PropTypes.string.isRequired,
    userDetails: PropTypes.string.isRequired,
    auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
    userDetails: state.oktaState.oktaState.userName,
    auth: state.oktaState.auth,
});

export default connect(
    mapStateToProps,
)(withAuth(AppGreeting));
